// @flow
import React, { Fragment } from 'react';
import TeaserModel from 'Stores/TeaserModel';
import Price from 'Components/Price';
import FocusedImage from 'Components/FocusedImage';
import CallToAction from 'Components/CallToAction';
import { formatPrice, isExternalLink, checkRelativeLink, stripTags } from 'Utils';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import DealerModel from 'Stores/DealerModel';
import { lowerCase6e } from 'Utils/special/lowerCaseSpecial';
import Typography from 'Components/Typography';

const cx = classNames.bind(styles);

type Props = {
  teaser: TeaserModel,
  stage: boolean,
  onOpenContact: () => void,
  consumption?: string,
  dealer: DealerModel,
};

type State = {
  hover: boolean,
};

export default class Item extends React.Component<Props, State> {
  state = {
    hover: false,
  };

  onMouseOver = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseOut = () => {
    this.setState({
      hover: false,
    });
  };

  render() {
    const { teaser, onOpenContact, consumption, dealer } = this.props;
    // use custom target instead of the one given in `link.target`
    let target = isExternalLink(teaser.linkUrl) ? '_blank' : undefined;
    // use custom href instead of the one given in `link.href`
    const linkHref = checkRelativeLink(teaser.linkUrl);
    const hasCTA = teaser.linkUrl || teaser.link.mazdaForm;
    const consumptionText = teaser.consumptionText || consumption;

    return (
      <Fragment>
        <div
          className={cx('teaser', {
            stage: this.props.stage,
            content: !this.props.stage,
          })}
          key={teaser.id}
        >
          <div className={cx('container', { hover: this.state.hover })}>
            <div className={styles.image}>
              <FocusedImage
                image={teaser.image}
                imageMobile={this.props.stage ? undefined : teaser.imageMobile}
                fullWidth
              />
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.box}>
              {teaser.topic && (
                <p
                  className={styles.h4}
                  dangerouslySetInnerHTML={{ __html: lowerCase6e(teaser.topic) }}
                />
              )}
              {teaser.title && (
                <Typography.Headline
                  level={'h4'}
                  className={styles.headline}
                  value={lowerCase6e(teaser.title)}
                  additionalAriaLabelText={consumptionText}
                />
              )}
              {!this.props.stage && teaser.text && (
                <div className={styles.text} dangerouslySetInnerHTML={{ __html: teaser.text }} />
              )}
              {teaser.hasPrice() && teaser.price > 0 && (
                <div className={styles.price}>
                  <Price
                    value={formatPrice(teaser.price)}
                    prefix={teaser.getPriceType()}
                    small
                    light
                  />
                  {teaser.priceText && (
                    <h5 dangerouslySetInnerHTML={{ __html: teaser.priceText }} />
                  )}
                </div>
              )}
              {hasCTA && this.props.stage && (
                <div className={cx('button', 'primary')}>
                  <CallToAction
                    {...teaser.link}
                    onOpenContact={onOpenContact}
                    href={linkHref}
                    target={target}
                    label={teaser.linkTitle || 'Mehr Infos'}
                    buttonVariant="secondary"
                    onMouseOver={this.onMouseOver}
                    onMouseOut={this.onMouseOut}
                    light
                    small
                  />
                </div>
              )}
            </div>
            {hasCTA && (
              <div className={styles.button}>
                <CallToAction
                  {...teaser.link}
                  onOpenContact={onOpenContact}
                  href={linkHref}
                  target={target}
                  label={teaser.linkTitle || 'Mehr Infos'}
                  buttonVariant="secondary"
                  light
                />
              </div>
            )}
          </div>
        </div>
        {consumptionText && (
          <div
            className={cx('consumptionCenter', { consumptionWhite: !this.props.stage })}
            aria-hidden="true"
          >
            <div dangerouslySetInnerHTML={{ __html: consumptionText }} />
          </div>
        )}
      </Fragment>
    );
  }
}
